import dayjs from 'dayjs';

export const HISTORICAL_START_DATE_CONDITION_KEY = 'historicalStartDate';
export const HISTORICAL_START_DATE_CONDITION_PARAMETER_NAME = 'startDate';
export const HISTORICAL_DAYS_BACK_CONDITION_KEY = 'historicalDaysBack';
export const HISTORICAL_DAYS_BACK_CONDITION_PARAMETER_NAME = 'daysBack';

export const isValidDateString = (dateStr: string): boolean => {
    if (!dateStr) return false;
    return dayjs(dateStr).isValid();
};

export const isValidPositiveInteger = (value: string): boolean => {
    if (!value) return false;
    const num = Number(value);
    return Number.isInteger(num) && num >= 0;
};

// Centralized validation registry for ACL conditions
// To add a new condition type:
// 1. Add the condition key and parameter name constants above
// 2. Add an entry here with the parameter name and validation function
// 3. Update AclConditionsDropDown.tsx CreateAclConditionValueInput switch statement to render the input
export const CONDITION_VALIDATORS: Record<string, { parameterName: string; validate: (value: string) => boolean }> = {
    [HISTORICAL_START_DATE_CONDITION_KEY]: {
        parameterName: HISTORICAL_START_DATE_CONDITION_PARAMETER_NAME,
        validate: isValidDateString
    },
    [HISTORICAL_DAYS_BACK_CONDITION_KEY]: {
        parameterName: HISTORICAL_DAYS_BACK_CONDITION_PARAMETER_NAME,
        validate: isValidPositiveInteger
    }
};
